import React, { useEffect } from 'react';
import { useModal } from 'components/modals/ModalContext';
import '../../../style/scss/attachment-viewer.scss';

interface AttachmentViewType {
    type: 'photo' | 'attachment';
    file: string;
    filename: string;
    description?: string;
}

const AttachmentViewer: React.FC<AttachmentViewType> = ({ 
    type, file, filename, description
}) => {
    const { revealModal } = useModal();

    // Reveal modal on component mount
    useEffect(() => revealModal(), []);

    // Determine wheter the attachment is an image
    const isImage = (filename: string) => {
        const extension = filename.split('.').pop()?.toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', '.heic', '.heif'].includes(extension || '');
    };

    return (
        <div className='attachment-viewer-modal'>
            <h4 className='header text-center'>{filename}</h4>
            {description && <div className="helper-text">{description}</div>}
            <div className={`content ${type === 'photo' ? 'photo-content' : 'attachment-content'}`}>
                {type === 'attachment' ? (
                    isImage(filename) ? (
                        <div className="photo-viewer">
                            <img src={file} alt={filename} id="viewer-img" className="viewer-image" />
                        </div>
                    ) : (
                        <div className='attachment-viewer'>
                            <iframe src={file} frameBorder="0"></iframe>
                        </div>
                    )
                ) : (
                    <div className="photo-viewer">
                        <img src={file} alt={filename} id="viewer-img" className="viewer-image" />
                    </div>
                )}
            </div>
        </div>
    )
}

export default AttachmentViewer;